<template>
  <div class="container" fluid>
    <b-modal id="deleteUrlSource" title="Apagar Fonte" @ok="DeleteUrlSouce">
      <div class="row">
        <div class="col">Tem a certeza que pretende eliminar esta fonte ?</div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "DeleteUrl",

  data() {
    return {};
  },

  props: {
    sourceUrl: Number,
  },

  components: {},

  methods: {
    async DeleteUrlSouce() {
      await this.$api.data.destroyById(this.sourceUrl);
      this.$emit("ok");
      this.$forceUpdate();
    },
  },
  mounted: function () {},
};
</script>


// WEBPACK FOOTER //
// src/components/Sources/DeleteUrl.vue